import createAPI from '../axios'

// 资源申请模板管理 API
const graduateManage = {
    personnelManage: {
        queryList: config => createAPI('/graduateManage/personnelManage/queryList', 'post', config),

        initCombo: config => createAPI('/graduateManage/personnelManage/initCombo', 'post', config),

        save: config => createAPI('/graduateManage/personnelManage/save', 'post', config),

        del: config => createAPI('/graduateManage/personnelManage/del', 'post', config),
    },
    groupInfo: {
        queryList: config => createAPI('/graduateManage/groupInfo/queryList', 'post', config),

        initCombo: config => createAPI('/graduateManage/groupInfo/initCombo', 'post', config),

        save: config => createAPI('/graduateManage/groupInfo/save', 'post', config),

        del: config => createAPI('/graduateManage/groupInfo/del', 'post', config),

        queryTeaList: config => createAPI('/graduateManage/groupInfo/queryTeaList', 'post', config),

        teaTree: config => createAPI('/graduateManage/groupInfo/teaTree', 'post', config),

        addTea: config => createAPI('/graduateManage/groupInfo/addTea', 'post', config),

        delTea: config => createAPI('/graduateManage/groupInfo/delTea', 'post', config),

        changeGroupLeader: config => createAPI('/graduateManage/groupInfo/changeGroupLeader', 'post', config),

        queryStuList: config => createAPI('/graduateManage/groupInfo/queryStuList', 'post', config),

        stuTree: config => createAPI('/graduateManage/groupInfo/stuTree', 'post', config),

        addStu: config => createAPI('/graduateManage/groupInfo/addStu', 'post', config),

        loadZdjsCombo: config => createAPI('/graduateManage/groupInfo/loadZdjsCombo', 'post', config),

        changeZdjs: config => createAPI('/graduateManage/groupInfo/changeZdjs', 'post', config),

        loadClassCombo: config => createAPI('/graduateManage/groupInfo/loadClassCombo', 'post', config),

        delStu: config => createAPI('/graduateManage/groupInfo/delStu', 'post', config),

        saveDeptSet: config => createAPI('/graduateManage/groupInfo/saveDeptSet', 'post', config),

        loadDeptSet: config => createAPI('/graduateManage/groupInfo/loadDeptSet', 'post', config),

        upload: config => createAPI('/graduateManage/groupInfo/upload', 'post', config),

        loadFileTable: config => createAPI('/graduateManage/groupInfo/loadFileTable', 'post', config),

        delFile: config => createAPI('/graduateManage/groupInfo/delFile', 'post', config),

        listSynchronization: config => createAPI('/graduateManage/groupInfo/listSynchronization', 'post', config),

        uploadImport: config => createAPI('/graduateManage/groupInfo/uploadImport', 'post', config),

    },
    projectAudit: {
        queryList: config => createAPI('/graduateManage/projectAudit/queryList', 'post', config),

        initCombo: config => createAPI('/graduateManage/projectAudit/initCombo', 'post', config),

        exportBatch: config => createAPI('/graduateManage/projectAudit/exportBatch', 'post', config),
    },
    graduationProject: {
        initData: config => createAPI('/graduateManage/graduationProject/initData', 'post', config),

        save: config => createAPI('/graduateManage/graduationProject/save', 'post', config),

        upload: config => createAPI('/graduateManage/graduationProject/upload', 'post', config),

        audit: config => createAPI('/graduateManage/graduationProject/audit', 'post', config),

        submitButton: config => createAPI('/graduateManage/graduationProject/submitButton', 'post', config),

        del: config => createAPI('/graduateManage/graduationProject/del', 'post', config),

        zsMethod: config => createAPI('/graduateManage/graduationProject/zsMethod', 'post', config),

        saveResetEntering: config => createAPI('/graduateManage/graduationProject/saveResetEntering', 'post', config),

        verifyProcess: config => createAPI('/graduateManage/graduationProject/verifyProcess', 'post', config),

        noAnswer: config => createAPI('/graduateManage/graduationProject/noAnswer', 'post', config),
    },
};

export default graduateManage;



// WEBPACK FOOTER //
// ./src/api/modules/graduateManage.js